var map = {
	"./Unauthorized.jpg": 10610,
	"./achievement.svg": 45847,
	"./announcement.svg": 30951,
	"./bg.png": 32525,
	"./birthday-cake.svg": 41598,
	"./blog/comment.jpg": 16526,
	"./calender/icon.png": 15928,
	"./close-diary.svg": 34948,
	"./company.png": 87179,
	"./conveyance.svg": 84123,
	"./customizer/1.png": 75805,
	"./customizer/2.png": 94598,
	"./customizer/3.png": 33615,
	"./customizer/4.png": 37744,
	"./customizer/5.png": 43993,
	"./dashboard-3/shap.png": 32173,
	"./dashboard/welcome.png": 50663,
	"./eye.png": 52385,
	"./female-user.png": 36082,
	"./forms/user.png": 92157,
	"./gif/danger.gif": 32467,
	"./gif/logout.gif": 52496,
	"./human-resources.svg": 6733,
	"./landing/footer.png": 76645,
	"./landing/landing-home/home-bg.jpg": 53261,
	"./leave.png": 60511,
	"./leave.svg": 68687,
	"./login/1.jpg": 76369,
	"./login/2.jpg": 44166,
	"./login/3.jpg": 34275,
	"./login/login_bg.jpg": 87665,
	"./logo/iifm_white.png": 44077,
	"./logo/logo-1.png": 29433,
	"./logo/logo-icon.png": 25485,
	"./logo/logo.png": 26447,
	"./logo/logo_iifm_blue.png": 48118,
	"./male-user-2.png": 27742,
	"./manager.svg": 43247,
	"./marker-icon-2x.png": 20759,
	"./marker-icon.png": 44830,
	"./no-notes.png": 93249,
	"./note-added-1.svg": 52817,
	"./notes-count.svg": 54251,
	"./other-images/bg-profile.png": 63887,
	"./other-images/boxbg.jpg": 70138,
	"./other-images/coming-soon-bg.jpg": 81823,
	"./other-images/maintenance-bg.jpg": 58465,
	"./policy.png": 2034,
	"./press-release.svg": 8767,
	"./ring.svg": 63692,
	"./social-app/social-image.png": 68709,
	"./switch/square-gray.png": 96710,
	"./switch/square.svg": 16044,
	"./user.png": 37577,
	"./welcome-modal.jpeg": 65631,
	"./work-hour-1.svg": 38046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34002;